import { render } from "./ServiceVue.vue?vue&type=template&id=082f7566&scoped=true"
import script from "./ServiceVue.vue?vue&type=script&lang=js"
export * from "./ServiceVue.vue?vue&type=script&lang=js"

import "./ServiceVue.vue?vue&type=style&index=0&id=082f7566&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082f7566"]])

export default __exports__